angular.module("digitalLeasing.module").component("customerTable", {
  templateUrl: "ng/components/digitalLeasing/customerSelection/customerTable/customerTable.view.html",
  bindings: {
    list: "<",
    onCustomerChosen: "&",
    customerIsOk: "&",
    customerIsNotOk: "&",
    callNextStep: '&',
    isSearchPf: '<',
    changeLabelActive: '<'
  },
  controllerAs: "CustomerTableCtrl",
  controller: CustomerTableController
});

function CustomerTableController(
  FinancialCustomer,
  RiUserG,
  $rootScope) {
  var self = this;

  self.$onInit = function () {
    self.showTable = true;
    self.$rootScope = $rootScope
    self.disableDoubleClick = false;
    if (self.list && self.list.length == 1) {
      self.select(0);
    }
    if (self.list && self.list.length == 1 && (!self.list[0].cf && !self.list[0].ndg && !self.list[0].ragSoc)) {
      self.showTable = false;
    }
  };

  self.isRowSelected = function (index) {
    if (self.selected && self.list[index].ndg == self.selected.ndg &&
      self.list[index].identifier == self.selected.identifier) {
      self.customerIsOk();
      return true;
    }
    return false;
  };

  self.select = function (index) {
    self.selected = self.list[index];
    self.onCustomerChosen({
      customer: FinancialCustomer.build(self.selected)
    });
    console.info("FinancialCustomer: ", self.selected);
  };

  self.doubleClick = function (index) {
    self.$rootScope.disableDoubleClick = true;
    self.callNextStep();
  }
}